import { useCallback } from 'react';
import { useQueryClient } from 'react-query';
import { cloneDeep, get, isNil, set } from 'lodash';

export const DYNAMIC_REPORT_QUERY_PREFIX = 'DYNAMIC_REPORT_QUERY_PREFIX';

export const useDynamicReportCache = () => {
    const queryClient = useQueryClient();
    const getter = useCallback(
        ({ accountId, reportId, dynamicReportPropName }) => {
            const dynamicReport = queryClient.getQueryData([DYNAMIC_REPORT_QUERY_PREFIX, accountId, reportId]);
            return dynamicReportPropName ? get(dynamicReport, dynamicReportPropName) : dynamicReport;
        },
        [queryClient]
    );
    const setter = useCallback(
        ({ accountId, reportId, dynamicReportPropName, value }) => {
            if (isNil(accountId) || isNil(reportId)) {
                return;
            }

            let newDynamicReport = value;

            if (dynamicReportPropName) {
                const dynamicReport =
                    queryClient.getQueryData([DYNAMIC_REPORT_QUERY_PREFIX, accountId, reportId]) ?? {};
                newDynamicReport = cloneDeep(dynamicReport);
                set(newDynamicReport, dynamicReportPropName, value);
            }

            if (newDynamicReport) {
                queryClient.setQueryData([DYNAMIC_REPORT_QUERY_PREFIX, accountId, reportId], newDynamicReport);
                return;
            }

            queryClient.removeQueries([DYNAMIC_REPORT_QUERY_PREFIX, accountId, reportId], newDynamicReport);
        },
        [queryClient]
    );

    return { getter, setter };
};
